import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.link";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      form: {
        id: "",
        game_type_id: "",
        name: "",
        pic: "",
        link: "",
        desc: "",
        icon: "",
        status: 1
      },
      iconfileList: [],
      picfileList: [],
      rules: {
        name: [{
          required: true,
          message: "请输入游戏名称",
          trigger: "blur"
        }],
        game_type_id: [{
          required: true,
          message: "请选择游戏类型",
          trigger: "blur"
        }],
        pic: [{
          required: true,
          message: "请上传宣传图",
          trigger: "blur"
        }],
        link: [{
          required: true,
          message: "请输入跳转链接",
          trigger: "blur"
        }],
        desc: [{
          required: true,
          message: "请输入描述",
          trigger: "blur"
        }],
        icon: [{
          required: true,
          message: "请上传游戏图标",
          trigger: "blur"
        }]
      },
      gameTypeList: []
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$refs.newPopover.open();

                _this.$api.gameType().then(function (res) {
                  if (res.code == 0) {
                    _this.gameTypeList = res.data.list;
                  }
                });

                if (data) {
                  _this.form = {
                    id: data.id,
                    game_type_id: data.game_type_id,
                    name: data.name,
                    pic: data.pic,
                    link: data.link,
                    desc: data.desc,
                    icon: data.icon,
                    status: data.status
                  };

                  _this.$nextTick(function () {
                    _this.$refs.iconUploadImage.echos(data.icon);

                    _this.$refs.picUploadImage.echos(data.pic);
                  });
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    iconUrl: function iconUrl(e) {
      this.iconfileList = e;
      this.form.icon = e.toString();
    },
    picUrl: function picUrl(e) {
      this.picfileList = e;
      this.form.pic = e.toString();
    },
    clearData: function clearData(id) {
      this.form = {
        id: id,
        game_type_id: "",
        name: "",
        pic: "",
        link: "",
        desc: "",
        icon: "",
        status: 1
      };
      this.$refs.iconUploadImage.emptyFeil();
      this.$refs.picUploadImage.emptyFeil();
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.form.id ? 'updGame' : 'addGame';

          _this2.$api[reqFn](_this2.form).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.$refs.newPopover.hide();

              _this2.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};